window.addEventListener('load', function () {
    mixpanel.init(getKey(), {track_pageview: true, ignore_dnt: true, disable_persistence: true, ip: false});
});

var fireStoreClicks = function(element, store, context) {
    element.addEventListener('click', function() {
        mixpanel.track('App Store Click', {
            'store': store,
            'context': context
          })
    });
}

fireStoreClicks(document.getElementById('play-link-home-hero'), 'play_store', 'home-hero');
fireStoreClicks(document.getElementById('apple-link-home-hero'), 'app_store', 'home-hero');

fireStoreClicks(document.getElementById('play-link-footer'), 'play_store', 'footer');
fireStoreClicks(document.getElementById('apple-link-footer'), 'app_store', 'footer');


var getKey = function () {
    if (location.hostname === "localhost" || location.hostname === "127.0.0.1") {
        return 'd9d42ad872a376bc25002c1fedfa0179';
    } else {
        return 'b448eaac034ce4f44cfe0217a8871260';
    }
}